export const PROFILE_MARKETING_STATUSES = {
  SUBSCRIBED: 'subscribed',
  NOT_SUBSCRIBED: 'not_subscribed',
  PENDING: 'pending',
};
